import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { usePanContext } from "@/app/contexts/PanContext";
import { panService } from "@/app/services/panService";
import { PanLinkResponse } from "@/app/services/panService/getLink";
import { Button } from "@/view/components/ui/button";
import { toast } from "@/view/components/ui/use-toast";
import { TickCircle } from "iconsax-react";

interface SentProposalProps {
  visible?: boolean;
}
export default function SentProposal({ visible }: SentProposalProps) {
  const navigate = useNavigate();
  const { transactionId, setCustomer, setProposal, setTransactionId } =
    usePanContext();

  const { data, isLoading, isError } = useQuery<PanLinkResponse>({
    queryKey: ["panLink", transactionId],
    queryFn: () => panService.getLink(transactionId!),
    enabled: !!transactionId && visible,
  });

  const backToDashboard = () => {
    setCustomer(null);
    setProposal(null);
    setTransactionId(null);
    navigate("/transacoes");
  };

  const copyLink = () => {
    if (data?.linkCliente) {
      toast({
        title: "Link da proposta copiado",
      });
    }
  };

  return (
    <div className={visible ? "flex flex-col gap-8" : "hidden"}>
      <div className="mt-10 flex flex-col items-start gap-1.5 px-6">
        <TickCircle variant="Bold" size={40} className="text-success" />
        <strong className="font-semibold">Proposta realizada</strong>
        <p className="text-sm font-medium text-black04">
          A proposta foi criada com sucesso. Envie o link ao clinete para que
          ele finalize a formalização. junto à instituição financeira. Você será
          avisado quando o processo for concluído.
        </p>
      </div>
      <div className="mt-6 flex justify-end gap-2">
        <Button
          variant="outline"
          className="w-[200px] rounded-full text-primary"
          onClick={copyLink}
          disabled={isLoading || isError || !data?.linkCliente}
        >
          Copiar link
        </Button>
        <Button
          className="w-[200px] rounded-full font-semibold text-white"
          onClick={backToDashboard}
        >
          Voltar para o início
        </Button>
      </div>
    </div>
  );
}
